import { PartProduct } from '@app/entities/Product';
import { handleError, handleResponse, MyAxios } from '@app/services/SettingAxios';
import { FilterTemplates } from '@entities/Filter';
import { RootState } from '@redux/store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { FilterElementsSchema } from '../types/filterElementsSchema';
import { FetchGetSchemaSideFilterDto } from './api.dto';
import {
  mockDataAkb,
  mockDataAkbAuto,
  mockDataDisks,
  mockDataDisksAuto,
  mockDataOils,
  mockDataTruckTyres,
  mockDataTyres,
  mockDataTyresAuto,
} from './mockdata';

export const fetchGetSchemaSideFilter = createAsyncThunk<FilterElementsSchema, FetchGetSchemaSideFilterDto>(
  'widgetFilter/fetchGetSchemaSideFilter',
  async ({ part, template, modificationId = null }, ApiThunk) => {
    const regionId = (ApiThunk.getState() as RootState).header?.data?.region?.REGION || 1;

    return await MyAxios.get(
      '/api/catalog/available-filters/?' +
        new URLSearchParams({
          part: part.toString(),
          template,
          regionId: regionId.toString(),
          ...(modificationId && { modificationId: modificationId.toString() }),
        }).toString(),
    )
      .then(handleResponse)
      .catch(error => handleError(error, getMockDataPart(part, template)));
  },
);

function getMockDataPart(part, template) {
  const dataMap = {
    [PartProduct.Tyres]: {
      [FilterTemplates.Tyres]: mockDataTyres,
      [FilterTemplates.TyresAuto]: mockDataTyresAuto,
    },
    [PartProduct.Disks]: {
      [FilterTemplates.Disks]: mockDataDisks,
      [FilterTemplates.DisksAuto]: mockDataDisksAuto,
    },
    [PartProduct.Batteries]: {
      [FilterTemplates.Akb]: mockDataAkb,
      [FilterTemplates.AkbAuto]: mockDataAkbAuto,
    },
    [PartProduct.Oils]: {
      [FilterTemplates.Oils]: mockDataOils,
    },
    [PartProduct.TruckTires]: {
      [FilterTemplates.TruckTyres]: mockDataTruckTyres,
    },
  };

  return dataMap[part] ? dataMap[part][template] : undefined;
}
